import React, { Component } from 'react';
var capitalLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
var lowerLetters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var symbols = ['`', '~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '-', '_', '=', '+', '[', ']', '\\', '', '\'', ',', '.', '/', '{', '}', '|', ':', '"', '<', '>', '?', '^'];
var getFromList = function getFromList(list) {
  return list[Math.floor(Math.random() * list.length)];
};
var randomCharacter = function randomCharacter(character, characters) {
  var randomChar = character;
  switch (characters) {
    case 'all':
      randomChar = getFromList([].concat(capitalLetters, lowerLetters, numbers, symbols));
      break;
    case 'capital-letters':
      randomChar = getFromList(capitalLetters);
      break;
    case 'lower-letters':
      randomChar = getFromList(lowerLetters);
      break;
    case 'numbers':
      randomChar = getFromList(numbers);
      break;
    case 'symbols':
      randomChar = getFromList(symbols);
      break;
    default:
      var isCapital = capitalLetters.includes(character);
      var isLower = lowerLetters.includes(character);
      var isNumber = numbers.includes(character);
      var isSymbol = symbols.includes(character);
      if (isCapital) randomChar = getFromList(capitalLetters);else if (isLower) randomChar = getFromList(lowerLetters);else if (isNumber) randomChar = getFromList(numbers);else if (isSymbol) randomChar = getFromList(symbols);else randomChar = getFromList([].concat(capitalLetters, lowerLetters, numbers, symbols));
      break;
  }
  return randomChar;
};
var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};
var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var changingLetter = {};
var textLength = 0;
var timeoutWrite = undefined;
var defaultOptions = {
  changes: 4,
  speed: 50
};
var hackerTextFunction = function hackerTextFunction(text, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!callback) return;
  if (timeoutWrite) clearTimeout(timeoutWrite);
  if (textLength > text.length) {
    verifyConsistency(text);
  }
  textLength = text.length;
  var textIndex = text.length - 1;
  options = _extends({}, defaultOptions, options);
  if (!changingLetter[textIndex]) changingLetter[textIndex] = {
    index: textIndex,
    changes: 0,
    original: text[textIndex]
  };
  verifyLettersToChange(text, callback, options);
};
var verifyLettersToChange = function verifyLettersToChange(text, callback, options) {
  var hackerText$$1 = '';
  for (var index = 0; index < text.length; index++) {
    var char = text[index];
    if (typeof changingLetter[index] === 'undefined') {
      hackerText$$1 += char;
      continue;
    }
    changingLetter[index].changes++;
    var isFinishedChanges = changingLetter[index].changes >= options.changes;
    if (isFinishedChanges) {
      changingLetter[index].showingLetter = changingLetter[index].original;
      hackerText$$1 += changingLetter[index].original;
    } else {
      var randomChar = randomCharacter(char, options.characters);
      changingLetter[index].showingLetter = randomChar;
      hackerText$$1 += randomChar;
    }
  }
  callback(hackerText$$1);
  timeoutWrite = setTimeout(function () {
    return verifyLettersToChange(text, callback, options);
  }, options.speed);
};
var verifyConsistency = function verifyConsistency(text) {
  Object.keys(changingLetter).forEach(function (key) {
    var char = text[key];
    if (typeof changingLetter[key] === 'undefined' || typeof changingLetter[key].showingLetter === 'undefined') return;
    if (char !== changingLetter[key].showingLetter) changingLetter[key] = undefined;
  });
};
var HackerText = function (_Component) {
  inherits(HackerText, _Component);
  function HackerText() {
    var _ref;
    var _temp, _this, _ret;
    classCallCheck(this, HackerText);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = HackerText.__proto__ || Object.getPrototypeOf(HackerText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hackerText: ''
    }, _this.changingLetter = {
      index: 0,
      changes: 0
    }, _this.write = function () {
      var _this$props = _this.props,
        _this$props$text = _this$props.text,
        text = _this$props$text === undefined ? '' : _this$props$text,
        _this$props$changes = _this$props.changes,
        changes = _this$props$changes === undefined ? 4 : _this$props$changes,
        _this$props$speed = _this$props.speed,
        speed = _this$props$speed === undefined ? 50 : _this$props$speed,
        characters = _this$props.characters,
        onFinished = _this$props.onFinished;
      var isLastChange = _this.changingLetter.changes === changes - 1;
      var character = isLastChange ? text[_this.changingLetter.index] : randomCharacter(text[_this.changingLetter.index], characters);
      _this.setState({
        hackerText: '' + text.substring(0, _this.changingLetter.index) + character
      });
      _this.changingLetter.changes++;
      if (_this.changingLetter.changes >= changes) _this.changingLetter = {
        index: ++_this.changingLetter.index,
        changes: 0
      };
      if (_this.changingLetter.index < text.length) _this.timeoutWrite = setTimeout(_this.write, speed);else _this.setState({
        hackerText: text
      }, onFinished);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  createClass(HackerText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      var _props$delay = this.props.delay,
        delay = _props$delay === undefined ? 0 : _props$delay;
      this.timeoutDelay = setTimeout(function () {
        if (_this2.props.onStart) _this2.props.onStart();
        _this2.write();
      }, delay);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var _props = this.props,
        text = _props.text,
        _props$delay2 = _props.delay,
        delay = _props$delay2 === undefined ? 0 : _props$delay2;
      if (text !== prevProps.text) {
        this.changingLetter = {
          index: 0,
          changes: 0
        };
        this.timeoutDelay = setTimeout(function () {
          if (_this3.props.onStart) _this3.props.onStart();
          _this3.write();
        }, delay);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutDelay);
      clearTimeout(this.timeoutWrite);
    }
  }, {
    key: 'render',
    value: function render() {
      var hackerText$$1 = this.state.hackerText;
      var _props2 = this.props,
        text = _props2.text,
        changes = _props2.changes,
        speed = _props2.speed,
        delay = _props2.delay,
        characters = _props2.characters,
        onStart = _props2.onStart,
        onFinished = _props2.onFinished,
        _props2$element = _props2.element,
        element = _props2$element === undefined ? 'span' : _props2$element,
        props = objectWithoutProperties(_props2, ['text', 'changes', 'speed', 'delay', 'characters', 'onStart', 'onFinished', 'element']);
      return React.createElement(element, props, hackerText$$1);
    }
  }]);
  return HackerText;
}(Component);
export default HackerText;
export { hackerTextFunction };